import { z } from 'zod';

export const GithubStatusSchema = z.object({
	status: z.enum(['connected', 'expired', 'not_connected']),
});
export type GithubStatus = z.infer<typeof GithubStatusSchema>;

export const GithubAuthorizeSchema = z.object({
	redirectUrl: z.string(),
});
export type GithubAuthorize = z.infer<typeof GithubAuthorizeSchema>;

export const GithubDisconnectSchema = z.object({
	disconnected: z.boolean(),
});
export type GithubDisconnect = z.infer<typeof GithubDisconnectSchema>;
